import React, { FunctionComponent } from 'react';
import { BrandHeading } from '../../organisms/brandHeading';
import { BrandAboutCompany } from '../../organisms/brandAboutCompany';
import { CompanyRecruitment } from '../../organisms/companyRecruitment';
import { RecruitmentShowContentFollow } from '../../molecules/recruitmentShowContentFollow';
import type { Props as ComponentProps } from './types';

type Props = ComponentProps & {
  brandId: number;
  isPc: boolean;
  chromeEdg: boolean;
  isShowingStoppedList: boolean;
  handleToggleStoppedList: () => void;
};

export const Presentation: FunctionComponent<Props> = ({
  brandId,
  isAllStoppedRecruitments,
  companyId,
  adminBrandId,
  user,
  coverNoImg,
  instagramIcon,
  noimage,
  hoverIcon,
  isPc,
  company,
  isPage,
  h1Title,
  description,
  isCompany,
  chromeEdg,
  lineIcon,
  occupations,
  preferredOccupations,
  occupationDetails,
  graduationArray,
  graduationAnnotaion,
  prefectures,
  hasAnyRecruitments,
  isShowAttentionPeople,
  isStoppedFv,
  isShowingStoppedList,
  handleToggleStoppedList,
}) => {
  return (
    <>
      <section className="brand__page">
        <BrandHeading
          brandId={brandId}
          instagramIcon={instagramIcon}
          noimage={noimage}
          dataCategory="brandcontent"
          dataValue="instagram"
          isStopped={isAllStoppedRecruitments}
          isStoppedFv={isStoppedFv}
        />
      </section>
      {isAllStoppedRecruitments && (
        <section className="brand__follow">
          <RecruitmentShowContentFollow
            companyId={companyId}
            adminBrandId={adminBrandId}
            user={user}
            noimage={coverNoImg}
            isDisplayed={true}
            isBrandPage={true}
            brandId={brandId}
            instagramIcon={instagramIcon}
            hoverIcon={hoverIcon}
            isPc={isPc}
            dataCategory="stopbrandcontent"
            dataValue={{
              companyName: 'company_name',
              brandCard: 'related_self_brands',
              brandcardInstagram: 'brandcard_instagram',
            }}
            lineIcon={lineIcon}
            occupations={occupations}
            occupationDetails={occupationDetails}
            graduationArray={graduationArray}
            preferredOccupations={preferredOccupations}
            graduationAnnotaion={graduationAnnotaion}
            prefectures={prefectures}
            isStoppedFv={isStoppedFv}
          />
        </section>
      )}
      <section className="brand_recruitment">
        <CompanyRecruitment
          company={company}
          brandId={brandId}
          noimage={noimage}
          hoverIcon={hoverIcon}
          isStopped={isAllStoppedRecruitments}
          isCompany={isCompany}
          isPage={isPage}
          h1Title={h1Title}
          description={description}
          shouldChangeUrl={false}
          isBrandPage={true}
          isShowingStoppedList={isShowingStoppedList}
          handleToggleStoppedList={handleToggleStoppedList}
          hasAnyRecruitments={hasAnyRecruitments}
          isShowAttentionPeople={isShowAttentionPeople}
        />
      </section>
      <BrandAboutCompany
        brandId={brandId}
        instagramIcon={instagramIcon}
        noimage={noimage}
        hoverIcon={hoverIcon}
        isPc={isPc}
        dataCategory={{
          brandcontent: 'brandcontent',
          stopbrandcontent: 'stopbrandcontent'
        }}
        dataValue={{
          companyName: 'company_name',
          brandCard: 'related_self_brands',
          brandcardInstagram: 'brandcard_instagram',
        }}
        isAllStoppedRecruitments={isAllStoppedRecruitments}
      />
    </>
  );
};
